import { useRef, useState } from 'react';
import { Info } from 'lucide-react';

/**
 * Tooltip informativo (icono ⓘ). Se posiciona con position:fixed
 * calculando su ubicación con getBoundingClientRect, para que no lo
 * recorten contenedores con overflow:hidden.
 */
export default function InfoTip({ text }) {
  const [pos, setPos] = useState(null);
  const iconRef = useRef(null);

  const show = () => {
    if (iconRef.current) {
      const r = iconRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 6, left: r.left + r.width / 2 });
    }
  };

  return (
    <span style={{ position:'relative', display:'inline-block', marginLeft:4 }}>
      <span ref={iconRef} onMouseEnter={show} onMouseLeave={() => setPos(null)}
        style={{ display:'inline-flex', cursor:'pointer' }}>
        <Info size={13} style={{ color:'#c9a227', verticalAlign:'middle' }} />
      </span>
      {pos && (
        <span style={{
          position:'fixed',
          top: pos.top,
          left: pos.left,
          transform:'translateX(-50%)',
          background:'#1a1a1a',
          color:'#fff',
          fontSize:12,
          padding:'8px 12px',
          borderRadius:6,
          whiteSpace:'normal',
          width:260,
          zIndex:9999,
          boxShadow:'0 4px 16px rgba(0,0,0,0.4)',
          lineHeight:1.5,
          pointerEvents:'none',
        }}>{text}</span>
      )}
    </span>
  );
}
